<template>
  <v-card>
    <v-card-text>
      <v-form ref="icdForm">
        <v-row no-gutters>
          <v-col cols="12" class="py-5">
            <v-btn-toggle class="ml-2" v-model="language" mandatory>
              <v-btn v-for="l in languages" :value="l.value" small class="text-overline" :key="l.value">
                <strong class="mr-1">{{l.value}}</strong>
                <span>{{l.text}}</span>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="icd.code"
              :label="$gettext('Code')"
              filled
              class="px-2"
              :rules="required"
              :disabled="edit"
            ></v-text-field>
          </v-col>
          <v-col cols="6" v-if="!extension">
            <v-select
							v-model="icd.icd_chapter_id"
							:items="icdChapters"
							:label="$gettext('Chapter')"
							item-text="title"
							item-value="id"
							filled
							class="px-2"
							:rules="required"
              :disabled="edit"
						>
              <template slot="item" slot-scope="data">
                {{ data.item.id }} - {{ data.item.title }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="icd.information[language].title"
              :label="$gettext('Title')"
              filled
              class="px-2"
              :rules="required"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="icd.information[language].description"
              :label="$gettext('Description')"
              filled
              class="px-2"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-alert v-model="success" color="alert" type="success">
              <translate>Saved Successfully</translate>
            </v-alert>
            <v-alert v-model="error" color="red" type="error">
              <translate>Error</translate>
              <span>{{errorMessage}}</span>
            </v-alert>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn color="primary" text :to="{name: 'icd'}">
				<translate>Cancel</translate>
			</v-btn>
      <v-spacer></v-spacer>
			<v-btn
        depressed
				color="secondary"
        class="primary--text"
				@click="saveICD"
				:loading="saving"
			>
				<span v-if="edit" v-translate>Save</span>
        <span v-else v-translate>Create</span>
			</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  name: "ICDForm",
  props: ["icd", "edit", "extension"],
  data: () => ({
    saving: false,
    error: false,
    success: false,
    errorMessage: "",
    language: 'pt'
  }),
  computed: {
    required() {
      return [v => !!v || this.$gettext("Required.")]
    },
    languages() {
      return [
        {value: 'pt', text: this.$gettext('Portuguese')},
        {value: 'en', text: this.$gettext('English')}
      ]
    },
    icdChapters() {
      return this.$store.getters.icdChapters;
    }
  },
  methods: {
    getForm() {
      console.log("get form");
      if(this.$refs.icdForm.validate()) {
        const form = new FormData();
        form.append("code", this.icd.code);
        if(!this.extension) form.append("icd_chapter_id", this.icd.icd_chapter_id);
        form.append("information_json", JSON.stringify(this.icd.information));
        return form;
      }
      return false;
    },
    saveICD() {
      this.error = false;
      this.success = false;
      this.errorMessage = "";
      let form = this.getForm();
      if(form) {
        this.saving = true;
        let endpoint;
        if(this.edit) {
          if(!this.extension) endpoint = "/icd/" + this.icd.id + "/edit";
          else endpoint = "/extension-codes/" + this.icd.id + "/edit";
        }
        else {
          if(!this.extension) endpoint = "/icd/new";
          else endpoint = "/extension-codes/new";
        }
        axios
					.post(endpoint, form)
					.then(response => {
						console.log(response.data);
						this.saving = false;
						if (response.data.result == "ok") {
							this.success = true;
              this.icd = response.data.disease;
              if(!this.edit) this.$router.push({name: 'icd'});
            } else {
							this.error = true;
							this.errorMessage = response.data.error;
						}
					})
					.catch(error => {
						this.saving = false;
						this.error = true;
						console.log(error);
					});
      }
    }
  },
  created() {
    if(!this.extension) this.$store.dispatch('GET_ICD_CHAPTERS');
  }
}
</script>